import { motion } from "framer-motion";
import { PenLine, FileText, Users, CreditCard, CheckCircle2 } from "lucide-react";
import { ADMISSION_STEPS } from "../../lib/constants";
import ApplyDialog from "./ApplyDialog";
import { Button } from "../ui/button";

const ICON_MAP = { PenLine, FileText, Users, CreditCard, CheckCircle2 };

const AdmissionProcess = () => {
  return (
    <section id="admissions" className="py-20 md:py-28 bg-white" data-testid="section-admissions">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10">
        <div className="text-center max-w-3xl mx-auto">
          <div className="text-xs font-semibold tracking-[0.2em] uppercase text-megha-accent">Admission Process</div>
          <h2 className="mt-2 font-heading font-extrabold text-3xl md:text-4xl lg:text-5xl tracking-tight text-megha-text">
            Five simple steps to your B.Tech seat.
          </h2>
        </div>

        <div className="mt-16 relative" data-testid="timeline-admissions">
          {/* Connector line - desktop */}
          <div className="hidden lg:block absolute top-10 left-[8%] right-[8%] h-0.5 bg-gradient-to-r from-megha-primary via-megha-accent to-megha-highlight" />

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-6 lg:gap-4">
            {ADMISSION_STEPS.map((s, i) => {
              const Icon = ICON_MAP[s.icon] || PenLine;
              return (
                <motion.div
                  key={s.step}
                  initial={{ opacity: 0, y: 24 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, margin: "-50px" }}
                  transition={{ delay: i * 0.08, duration: 0.5 }}
                  className="relative text-center"
                >
                  <div className="relative inline-flex items-center justify-center mx-auto">
                    <div className="w-20 h-20 rounded-full bg-gradient-to-br from-megha-primary to-megha-accent flex items-center justify-center text-white shadow-xl shadow-blue-900/20">
                      <Icon className="w-8 h-8" />
                    </div>
                    <div className="absolute -top-2 -right-2 w-8 h-8 rounded-full bg-megha-highlight text-megha-text font-heading font-extrabold text-xs flex items-center justify-center border-4 border-white">
                      {s.step}
                    </div>
                  </div>
                  <div className="font-heading font-extrabold text-megha-text text-lg mt-5">{s.title}</div>
                  <p className="text-sm text-slate-500 mt-2 max-w-[220px] mx-auto">{s.desc}</p>
                </motion.div>
              );
            })}
          </div>
        </div>

        <div className="mt-14 text-center">
          <ApplyDialog
            trigger={
              <Button
                data-testid="btn-start-admission"
                className="h-12 rounded-full bg-megha-highlight text-megha-text font-bold px-8 hover:opacity-95 shadow-lg shadow-yellow-500/30 hover:-translate-y-0.5 transition-all"
              >
                Start your admission
              </Button>
            }
          />
        </div>
      </div>
    </section>
  );
};

export default AdmissionProcess;
